import React, {
  useCallback
} from 'react';
import { ReactEditor, useSlateStatic } from 'slate-react';
import { Transforms } from 'slate';

import HelptapEditor from '../../helpers';
import BaseElement from '../base';

export function DataCollectionRow(props) {

  const { attributes, children } = props;

  const editor = useSlateStatic();

  const handleClick = useCallback((event) => {

    const node = ReactEditor.toSlateNode(editor, event.target);
    const path = HelptapEditor.getClosestEditableNodePathFromPath(editor, ReactEditor.findPath(editor, node));

    // if text node is not selected, 
    // which are usually paths with 3 or more elements, 
    // no need to select it
    if (path === null || path.length <= 2) {
      return;
    }

    Transforms.deselect(editor);
    Transforms.select(editor, path);

  }, [editor]);

  function renderRow() {

    const containerAttributes = {
      className: 'row-content-container'
    };

    return <React.Fragment>
      <div {...containerAttributes}>
        {children}
      </div>
    </React.Fragment>;

  }

  function renderRowElement() {

    const elementAttributes = {
      ...attributes,
      suppressContentEditableWarning: true,
      className: 'row',
      contentEditable: false,
      onClick: handleClick
    };

    return <div {...elementAttributes}>
      {renderRow()}
    </div>;
  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      customNodeControls: []
    };

    return (
      <BaseElement {...baseElementProperties}>
        {renderRowElement()}
      </BaseElement>
    );
  }

  return renderMain();
}